<template>
  <div class="page">
    <YorkbbsHeader width="1170px"></YorkbbsHeader>
    <YorkbbsSearch :placeholder="'请输入品牌/车系，如 奥迪A8​'"></YorkbbsSearch>
    <div class="page-wrapper">
      <ul class="tab-list">
        <li
          class="tab-item"
          :class="{ active: tabIndex === i }"
          v-for="(item, i) in tabs"
          :key="i"
          @click="onTabChange(i)"
        >
          {{ item.name }}
        </li>
      </ul>
      <div class="search-count">
        <span>为你找到{{ car.itemTotal }}辆车</span>
      </div>

      <YorkbbsSkeleton class="car-skeleton" :count="8" :loading="car.loading">
        <div slot="template" class="car-skeleton__item">
          <el-skeleton-item variant="image"></el-skeleton-item>
          <el-skeleton-item class="p1" variant="p"></el-skeleton-item>
          <el-skeleton-item class="p2" variant="p"></el-skeleton-item>
          <el-skeleton-item class="p3" variant="p"></el-skeleton-item>
        </div>
      </YorkbbsSkeleton>

      <div class="car-list" v-show="!car.loading">
        <template v-for="(item, i) in car.list">
          <YorkbbsUsedItem
            :key="`used-${i}`"
            v-if="item.app == 'car_post' && item.property.topics[0].englishName == 'used'"
            :data="item"
            :labelVisible="true"
            :topVisible="false"
          ></YorkbbsUsedItem>
          <YorkbbsLeaseItem
            :key="`lease-${i}`"
            v-else-if="item.app == 'car_post' && item.property.topics[0].englishName == 'lease'"
            :data="item"
            :topVisible="false"
          ></YorkbbsLeaseItem>
        </template>
      </div>

      <YorkbbsEmptyResult
        v-if="!car.loading && !car.list.length"
        text="没有搜索到你要找的车源，看看其他的吧"
      ></YorkbbsEmptyResult>

      <YorkbbsPagination
        v-if="car.itemTotal"
        :current-page.sync="car.offset"
        :page-size.sync="car.size"
        :total="car.itemTotal"
        @current-change="onPageChange"
      ></YorkbbsPagination>
    </div>

    <!-- 返回顶部 -->
    <YorkbbsBackup
      :publishVisible="true"
      :publishTitle="'卖车'"
      :publishURL="'/publish/used'"
      :homeVisible="true"
      :homeURL="'/center/information?type=4' | hostBuild('home')"
      :opinionVisible="true"
    ></YorkbbsBackup>
  </div>
</template>
<script>
import { topics } from '../components/data';
import { setHtmlMeta } from '@/utils/utils';
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsSearch from '../components/topic.vue';
import YorkbbsUsedItem from '../components/item-used.vue';
import YorkbbsLeaseItem from '../components/item-lease.vue';
import YorkbbsPagination from '../components/pagination.vue';
import YorkbbsEmptyResult from '@/common/empty-result/empty-result.vue';
import YorkbbsBackup from '@/common/tools-backup.vue';
import YorkbbsSkeleton from '@/common/skeleton.vue';

export default {
  name: 'Search',
  components: {
    YorkbbsHeader,
    YorkbbsSearch,
    YorkbbsUsedItem,
    YorkbbsLeaseItem,
    YorkbbsPagination,
    YorkbbsEmptyResult,
    YorkbbsBackup,
    YorkbbsSkeleton,
  },
  data() {
    return {
      // 选项卡列表
      tabs: [{ name: '全部' }, { name: '二手车' }, { name: '转Lease' }],
      // 选项卡索引
      tabIndex: 0,
      // 车源列表
      car: {
        loading: false,
        offset: 1,
        size: 12,
        itemTotal: 0,
        list: [],
      },
    };
  },
  created() {
    const tabIndex = Number(this.$route.query.tab);
    this.tabIndex = Number.isNaN(tabIndex) ? 0 : tabIndex;
    this.car = this.$options.data().car;
    this.getPosts();
  },
  mounted() {
    setHtmlMeta({
      title: '搜索 - 加拿大汽车交易网 -  约克论坛',
      keywords: `${this.$route.query.keyword}`,
      description:
        '加拿大汽车交易网，是约克论坛旗下的汽车信息服务平台，提供加拿大多伦多地区最全最及时的新车、二手车、转lease信息，诚信靠谱的汽车销售为你的购车保驾护航！',
    });
  },
  methods: {
    /**
     * 翻页时
     */
    onPageChange(page) {
      this.car.offset = page;
      this.getPosts();
    },
    /**
     * 选项卡发生切换时
     */
    onTabChange(index) {
      if (this.tabIndex !== index) {
        this.$router.push({ query: { ...this.$route.query, tab: index } });
      }
    },
    /**
     * 获取车源列表
     */
    async getPosts() {
      const keyword = (this.$route.query.keyword || '').trim();
      if (keyword.length < 2) return this.$warning('搜索关键词不能少于2个');

      let topicIds;
      if (this.tabIndex > 0) {
        topicIds = [topics[this.tabIndex - 1].id];
      }

      this.car.loading = true;
      const { data } = await this.$axios
        .post('/car/v1/get/post/list', {
          offset: this.car.offset,
          size: this.car.size,
          topicIds,
          keyword,
          notRule: 1,
        })
        .finally(() => {
          this.car.loading = false;
        });

      this.car.list = data.items;
      this.car.itemTotal = data.itemTotal;
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
}
.page-header {
  margin-bottom: 15px;
}
.page-wrapper {
  width: 1170px;
  margin: auto;
}
.tab-list {
  display: flex;
  margin-bottom: 30px;
}
.tab-item {
  font-size: 22px;
  line-height: 30px;
  color: var(--text-color-9);
  font-weight: 500;
  margin-right: 25px;
  cursor: pointer;
  user-select: none;
  &.active {
    color: var(--text-color);
  }
}

.search-count {
  font-size: 16px;
  color: var(--text-color-3);
  line-height: 22px;
  margin-bottom: 20px;
}
.car-list {
  display: flex;
  flex-wrap: wrap;
  .used-item,
  .lease-item {
    &:not(:nth-child(4n)) {
      margin-right: 16.666666px;
    }
  }
}

.car-skeleton {
  margin-left: -10px;
  margin-right: -10px;
  .car-skeleton__item {
    width: 280px;
    padding: 10px;
    box-sizing: border-box;
  }
  ::v-deep {
    .el-skeleton {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 20px;
      text-align: center;
    }
    .el-skeleton__image {
      width: 258px;
      height: 195px;
      margin: auto;
    }
    .el-skeleton__p {
      display: block;
      margin-top: 13px;
    }
    .p1 {
      width: 80%;
    }
    .p2 {
      width: 40%;
    }
    .p3 {
      width: 60%;
    }
  }
}
</style>
